import React, { useState, useEffect } from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import { setLoadingState } from "../../../redux/AppSlice";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { MenuItem, Select } from "@mui/material";
import ProductCard from "./ProductCard";
import { useSelector, useDispatch } from "react-redux";
import { fetchFilteredProduct } from "../utils";
import { toast } from "react-toastify";

const CreateProductCatalog = () => {
	useEffect(() => {
		getFilteredProduct();
	}, []);
	const dispatch = useDispatch();
	const filterData = useSelector((state) => state.lease.filterData);
	const [productData, setProductData] = useState([]);

	const getFilteredProduct = async () => {
		dispatch(setLoadingState(true));
		// console.log(filterData)
		try {
			const product = await fetchFilteredProduct(filterData);
			console.log(product)
			if (product.length > 0) {
				dispatch(setLoadingState(false));
				// console.log(product);
				setProductData(product);
			} else {
				dispatch(setLoadingState(false));
				// toast.error("No product found");
			}
		} catch (error) {
			dispatch(setLoadingState(false));
			console.log(error);
			toast.error("No product found");
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<StyledForm className='mt-0' onSubmit={handleSubmit}>
			<div className='w-full'>
				<FormAccordion title='Create Lease' open={true}>
					<div className='sortHeader flex'>
						<div className='displayType'>
							<svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M9 19H19V17H9V19ZM9 13H15V11H9V13ZM9 5V7H21V5H9ZM5 4.5C4.80295 4.50007 4.60785 4.53894 4.42582 4.61441C4.2438 4.68988 4.07842 4.80046 3.93913 4.93984C3.79984 5.07922 3.68937 5.24467 3.61403 5.42675C3.53868 5.60882 3.49993 5.80395 3.5 6.001C3.50007 6.19805 3.53894 6.39315 3.61441 6.57518C3.68988 6.7572 3.80046 6.92258 3.93984 7.06187C4.07922 7.20116 4.24467 7.31163 4.42675 7.38697C4.60882 7.46232 4.80395 7.50107 5.001 7.501C5.39896 7.50087 5.78056 7.34265 6.06187 7.06116C6.34317 6.77967 6.50113 6.39796 6.501 6C6.50087 5.60204 6.34265 5.22044 6.06116 4.93913C5.77967 4.65783 5.39796 4.49987 5 4.5ZM5 10.5C4.80295 10.5001 4.60785 10.5389 4.42582 10.6144C4.2438 10.6899 4.07842 10.8005 3.93913 10.9398C3.79984 11.0792 3.68937 11.2447 3.61403 11.4267C3.53868 11.6088 3.49993 11.804 3.5 12.001C3.50007 12.198 3.53894 12.3932 3.61441 12.5752C3.68988 12.7572 3.80046 12.9226 3.93984 13.0619C4.07922 13.2012 4.24467 13.3116 4.42675 13.387C4.60882 13.4623 4.80395 13.5011 5.001 13.501C5.39896 13.5009 5.78056 13.3427 6.06187 13.0612C6.34317 12.7797 6.50113 12.398 6.501 12C6.50087 11.602 6.34265 11.2204 6.06116 10.9391C5.77967 10.6578 5.39796 10.4999 5 10.5ZM5 16.5C4.80295 16.5001 4.60785 16.5389 4.42582 16.6144C4.2438 16.6899 4.07842 16.8005 3.93913 16.9398C3.79984 17.0792 3.68937 17.2447 3.61403 17.4267C3.53868 17.6088 3.49993 17.804 3.5 18.001C3.50007 18.198 3.53894 18.3932 3.61441 18.5752C3.68988 18.7572 3.80046 18.9226 3.93984 19.0619C4.07922 19.2012 4.24467 19.3116 4.42675 19.387C4.60882 19.4623 4.80395 19.5011 5.001 19.501C5.39896 19.5009 5.78056 19.3427 6.06187 19.0612C6.34317 18.7797 6.50113 18.398 6.501 18C6.50087 17.602 6.34265 17.2204 6.06116 16.9391C5.77967 16.6578 5.39796 16.4999 5 16.5Z'
									fill='#00525D'
								/>
							</svg>
						</div>

						<div className='sortBy flex'>
							<h5 className='fw-500 mr-3'>Sort by:</h5>
							<Select value={"recommended"} className=''>
								<MenuItem value='recommended'>Recommended</MenuItem>
								<MenuItem value='date'>Date</MenuItem>
							</Select>
						</div>
					</div>

					{productData.length > 0 ? (
						productData.map((product) => {
							return <ProductCard key={product.objectId} data={product} />;
						})
					) : (
						<div className='w-full h-full flex justify-center items-center mt-4'>
							<h3 className=''>No product found</h3>
						</div>
					)}
				</FormAccordion>
			</div>
		</StyledForm>
	);
};

export default CreateProductCatalog;
